import React from 'react';
export function Footer() {
  return (<footer className="bg-white sticky-footer">
    <div className="container my-auto">
      <div className="text-center my-auto copyright"><span>Copyright © Dra. Carolina Kaufman 2020</span></div>
    </div>
  </footer>);
}
